import React, { useEffect } from 'react';
import { Dialog, Drawer, IconButton, useMediaQuery } from '@material-ui/core';
import { useChatAutoSelect, useChatConversation, useChatOpen } from '../../hooks';
import { CustomChatConversations } from '../conversations';
import CloseIcon from '@material-ui/icons/Close';
import { CustomChantMessages } from '../messages';
import { Theme } from '@material-ui/core/styles';
import { useAppDispatch, useAppSelector, useTranslate } from 'hooks';
import style from './index.module.scss';
import { actionChatGetConversations, selectChatStatuses } from 'components/custom-chat/store';

const CustomChantLayoutMobile: React.FC = () => {
  const { conversationID, onSelect: onSelectConversation } = useChatConversation();
  const { onClose } = useChatOpen();
  const { t } = useTranslate();
  const { isLoading } = useAppSelector(selectChatStatuses);

  return (
    <>
      <div className={style.wrap}>
        <div className={style.header}>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
          <div className={style.title}>{t('chat-messenger')}</div>
        </div>
        <div className={style.dialogs}>
          <CustomChatConversations
            isLoading={isLoading}
            conversationID={conversationID}
            onSelectConversation={onSelectConversation}
          />
        </div>
      </div>
      <Dialog open={Boolean(conversationID)} fullScreen={true}>
        <CustomChantMessages isShowClose />
      </Dialog>
    </>
  );
};
const CustomChantLayoutDesktop: React.FC = () => {
  const { t } = useTranslate();
  const { onClose } = useChatOpen();

  const { isLoading } = useAppSelector(selectChatStatuses);

  const { conversationID, onSelect: onSelectConversation } = useChatConversation();
  useChatAutoSelect();

  return (
    <div className={style.wrap}>
      <div className={style.header}>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <div className={style.title}>{t('chat-messenger')}</div>
      </div>
      <div className={style.messages}>
        <CustomChantMessages />
      </div>
      <div className={style.dialogs}>
        <CustomChatConversations
          isLoading={isLoading}
          conversationID={conversationID}
          onSelectConversation={onSelectConversation}
        />
      </div>
    </div>
  );
};

export const CustomChantLayout: React.FC = () => {
  const { isOpen, onClose } = useChatOpen();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  const { isLoading, isInit } = useAppSelector(selectChatStatuses);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isOpen && !isInit && !isLoading) {
      dispatch(actionChatGetConversations.request());
    }
  }, [isOpen, isInit, isLoading, dispatch]);

  return (
    <Drawer open={isOpen} onClose={onClose} anchor={'right'} disablePortal disableEnforceFocus>
      {isMobile ? <CustomChantLayoutMobile /> : <CustomChantLayoutDesktop />}
    </Drawer>
  );
};
